import { useEffect, useRef, useState } from 'react'
import Editor, { Toolbar } from 'react-simple-wysiwyg';

const ImagingRecordsFreetype = ({ patientDBdata, patientID, loggedUserProvider, setPatientDBdata, noteActualId }) => {

    const [imagingIds, setImagingIds] = useState([])

    const [patientImagings, setPatientImagings] = useState([])

    const [originalImagingHtml, setOriginalImagingHtml] = useState("")
    const [tempImagingHtml, setTempImagingHtml] = useState("")

    useEffect(() => {
        const metadataIds = patientDBdata?.currentNote?.data.metadata?.imagingIds
        setImagingIds(metadataIds || [])
        if (metadataIds !== null && metadataIds?.length > 0) {
            const findPatientImagings = patientDBdata?.allImaging?.filter((item) => metadataIds.includes(item.id))
            setPatientImagings(findPatientImagings || {})
        }
    }, [patientID])

    const handleBlur = async () => {

        if (tempImagingHtml === originalImagingHtml) return
        setOriginalImagingHtml(tempImagingHtml)
        setPatientDBdata((prev) => {
            return {
                ...prev,
                currentNote: {
                    ...prev?.currentNote,
                    data: {
                        ...prev?.currentNote?.data,
                        freeTypesEverything: {
                            ...prev?.currentNote?.data?.freeTypesEverything,
                            imagingHtml: tempImagingHtml
                        }
                    },
                },


                allNotes: prev?.allNotes?.map((note) => {
                    if (note?.id === noteActualId) {
                        const parsedData = note?.data ? JSON.parse(note.data) : {}

                        return {
                            ...note,
                            data: JSON.stringify({
                                ...parsedData,
                                freeTypesEverything: {
                                    ...parsedData?.freeTypesEverything,
                                    imagingHtml: tempImagingHtml
                                }
                            }),
                        }
                    }
                    return note
                }),
            }
        })
    }
    
    // useEffect(() => {
    //     if (!patientImagings.length) return

    //     const html = `
    //     <div>
    //         ${patientImagings
    //             .map(
    //                 (img) => `
    //             <div style="margin-bottom:12px;">
    //                 <div>
    //                     <strong>${img.date}</strong> - ${img.data?.name ?? ""}
    //                 </div>
    //                 <div style="margin-top:6px;">
    //                     ${img.data?.impression ?? ""}
    //                 </div>
    //             </div>
    //         `
    //             )
    //             .join("")}
    //     </div>
    // `
    //     setPatientDBdata((prev) => {
    //         return {
    //             ...prev,
    //             currentNote: {
    //                 ...prev?.currentNote,
    //                 data: {
    //                     ...prev?.currentNote?.data,
    //                     freeTypesEverything: {
    //                         ...prev?.currentNote?.data?.freeTypesEverything,
    //                         imagingHtml: tempImagingHtml
    //                     }
    //                 },
    //             },


    //             allNotes: prev?.allNotes?.map((note) => {
    //                 if (note?.id === noteActualId) {
    //                     const parsedData = note?.data ? JSON.parse(note.data) : {}

    //                     return {
    //                         ...note,
    //                         data: JSON.stringify({
    //                             ...parsedData,
    //                             freeTypesEverything: {
    //                                 ...parsedData?.freeTypesEverything,
    //                                 imagingHtml: tempImagingHtml
    //                             }
    //                         }),
    //                     }
    //                 }
    //                 return note
    //             }),
    //         }
    //     })

    //     const imagingHtml = patientDBdata?.currentNote?.data?.freeTypesEverything?.imagingHtml
    //     setOriginalImagingHtml(imagingHtml || html)
    //     setTempImagingHtml(imagingHtml || html)


    // }, [patientImagings])

    useEffect(() => {
    if (!patientImagings.length) return;

    const generatedHtml = `
        <div>
            ${patientImagings
                .map(
                    (img) => `
                <div style="margin-bottom:12px;">
                    <div>
                        <strong>${img.date}</strong> - ${img.data?.name ?? ""}
                    </div>
                    <div style="margin-top:6px;">
                        ${img.data?.impression ?? ""}
                    </div>
                </div>
            `
                )
                .join("")}
        </div>
    `;

    const savedHtml =
        patientDBdata?.currentNote?.data?.freeTypesEverything?.imagingHtml;

    if (savedHtml) {
        setOriginalImagingHtml(savedHtml);
        setTempImagingHtml(savedHtml);
        return;
    }

    setOriginalImagingHtml(generatedHtml);
    setTempImagingHtml(generatedHtml);

    setPatientDBdata((prev) => ({
        ...prev,
        currentNote: {
            ...prev?.currentNote,
            data: {
                ...prev?.currentNote?.data,
                freeTypesEverything: {
                    ...prev?.currentNote?.data?.freeTypesEverything,
                    imagingHtml: generatedHtml,
                },
            },
        },

        allNotes: prev?.allNotes?.map((note) => {
            if (note?.id === noteActualId) {
                const parsedData = note?.data ? JSON.parse(note.data) : {};

                return {
                    ...note,
                    data: JSON.stringify({
                        ...parsedData,
                        freeTypesEverything: {
                            ...parsedData?.freeTypesEverything,
                            imagingHtml: generatedHtml,
                        },
                    }),
                };
            }
            return note;
        }),
    }));
}, [patientImagings]);



    if (imagingIds.length === 0) {
        return null
    }


    return (
        <div className="d-flex align-items-start">
            <div style={{ minWidth: "23%" }}>Imagings</div>

            <div className="w-100">
                <Editor
                onBlur={handleBlur}
                    value={tempImagingHtml}
                    onChange={(e) => { setTempImagingHtml(e.target.value) }}
                    containerProps={{
                        style: {
                            width: "100%",
                            background: "#2D2D2D",
                            color: "white",
                            border: 0,
                        }
                    }}
                >
                    <Toolbar hidden />
                </Editor>

            </div>
        </div>
    )
}

export default ImagingRecordsFreetype